import React from 'react'
import './style.css'

const ContainerPure = ({ children }) => {
  return (
    <div className='content-container'>
      {children}
    </div>
  )
}

export default ContainerPure
